import { render, staticRenderFns } from "./ImageBanner.vue?vue&type=template&id=236af929&scoped=true"
import script from "./ImageBanner.vue?vue&type=script&lang=js"
export * from "./ImageBanner.vue?vue&type=script&lang=js"
import style0 from "./ImageBanner.vue?vue&type=style&index=0&id=236af929&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236af929",
  null
  
)

export default component.exports